import { FolderTreeNode } from '../../types/boardContent';
import './BoardExplorer.css';

interface FolderTreeProps {
  nodes: FolderTreeNode[];
  selectedFolderId: number | null;
  expandedIds: Set<number>;
  onToggle: (folderId: number) => void;
  onSelect: (folderId: number | null) => void;
  depth?: number;
}

function FolderTree({
  nodes,
  selectedFolderId,
  expandedIds,
  onToggle,
  onSelect,
  depth = 0,
}: FolderTreeProps) {
  return (
    <ul className="board-tree" style={{ paddingLeft: depth === 0 ? 0 : 14 }}>
      {depth === 0 && (
        <li>
          <button
            type="button"
            className={`board-tree__item${selectedFolderId == null ? ' is-active' : ''}`}
            onClick={() => onSelect(null)}
          >
            <span className="board-tree__icon">📁</span>
            <span>전체</span>
          </button>
        </li>
      )}
      {nodes.map((node) => {
        const hasChildren = node.children && node.children.length > 0;
        const expanded = expandedIds.has(node.folderId);
        return (
          <li key={node.folderId}>
            <div className="board-tree__row">
              <button
                type="button"
                className="board-tree__toggle"
                onClick={(event) => {
                  event.stopPropagation();
                  onToggle(node.folderId);
                }}
                aria-label={expanded ? '접기' : '펼치기'}
              >
                {hasChildren ? (expanded ? '▾' : '▸') : '·'}
              </button>
              <button
                type="button"
                className={`board-tree__item${
                  selectedFolderId === node.folderId ? ' is-active' : ''
                }`}
                onClick={() => onSelect(node.folderId)}
                title={node.folderName}
              >
                <span className="board-tree__icon">📂</span>
                <span>{node.folderName}</span>
              </button>
            </div>
            {hasChildren && expanded && (
              <FolderTree
                nodes={node.children}
                selectedFolderId={selectedFolderId}
                expandedIds={expandedIds}
                onToggle={onToggle}
                onSelect={onSelect}
                depth={depth + 1}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
}

export default FolderTree;
